/* eslint-disable react/jsx-key */
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Search from "@insite/mobius/Icons/Search";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import parse from "html-react-parser";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface Memberlist {
    fields: {
        img: string;
        image1: string;
        title: string;
        midText: string;
        lowerText1: string;
        lowerText2: string;
        image: string;
        path1: LinkFieldValue;
        path2: LinkFieldValue;
        description: string;
    };
}

const enum fields {
    divisions = "divisions",
}

interface OwnProps extends WidgetProps {
    fields: {
        maintitle: string;
        image: string;
        members: any;
        [fields.divisions]: Memberlist[];
        selectColumn: number;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    currentPage: getCurrentPage(state),
});

export interface Imgstyle {
    img?: InjectableCss;
    imgwrapper?: InjectableCss;
    twrapper?: TypographyProps;
    hwrapper?: InjectableCss;
    h1wrapper?: InjectableCss;
    parent?: GridContainerProps;
    main?: InjectableCss;
    button?: LinkPresentationProps;
    buttonWrapper?: InjectableCss;
    title?: TypographyProps;
    h2wrapper?: InjectableCss;
    parentContainer?: GridItemProps;
    styleIcon?: IconPresentationProps;
    description?: InjectableCss;
    textCircleContainer?: InjectableCss;
    circle?: InjectableCss;
}

export const imgstyle: Imgstyle = {
    img: {
        css: css`
            width: 100%;
            height: 100%;
            &::after {
                content: "";
                position: absolute;
                width: 49px;
                bottom: -24px;
                right: -24px;
                height: 49px;
                border: 2px solid transparent;
                background-color: ${COLORS.background.red};
                border-image-slice: 10%;
                transform: rotateZ(45deg);
            }
            img {
                width: 100%;
                height: auto;
                object-fit: cover;
                aspect-ratio: 6/2.5;
                position: relative;
                border-radius: 5px;
                opacity: 1;
                background-color: rgba(0, 110, 210, 0.059659);
                &::after {
                    content: "";
                    position: absolute;
                    width: 49px;
                    bottom: -24px;
                    right: -24px;
                    height: 49px;
                    border: 2px solid transparent;
                    background-color: white;
                    border-image-slice: 10%;
                    transform: rotateZ(45deg);
                }

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            aspect-ratio: 3.4/2.7;
                        `,
                        css`
                            aspect-ratio: 3.4/2.7;
                        `,
                        null,
                        null,

                        null,
                    ])}
            }
        `,
    },
    textCircleContainer: {
        css: css`
            display: flex;
            &:hover {
                .circle {
                    background: ${COLORS.yellow};
                    border: 0.25px solid rgba(17, 41, 69, 0.22);
                    box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, 0.64);
                }
            }
        `,
    },
    main: {
        css: css`
            padding-top: 22px;
            padding-bottom: 44px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-top: 15px;
                        padding-bottom: 15px;
                    `,
                    css`
                        padding-top: 15px;
                        padding-bottom: 15px;
                    `,
                    css`
                        padding-top: 22px;
                        padding-bottom: 22px;
                    `,
                    css`
                        margin-left: 10px;
                        margin-right: 10px;
                    `,

                    null,
                ])}
        `,
    },
    title: {
        variant: "h2",
        css: css`
            /* color: ${COLORS.primaryBlue}; */
            color: ${getColor("primary")};
            font-family: ${TYPOGRAPHY.fontFamily.barlow};
            font-weight: ${TYPOGRAPHY.weight.baseBold};
            font-style: normal;
            letter-spacing: ${TYPOGRAPHY.letterSpacing.smallish};
            text-align: center;
            text-transform: uppercase;
            padding-bottom: 15px;
        `,
    },

    imgwrapper: {
        css: css`
            padding-bottom: 25px;
            padding-right: 60px;
            width: auto;
            border: 0.5px solid rgba(0, 0, 0, 0.5);
            /* border-top: 6px solid ${COLORS.primaryBlue} !important; */
            border-top: 6px solid ${getColor("primary")}!important;
            box-shadow: 0px 2px 32px rgb(67 67 67 / 50%);
            background: linear-gradient(90deg, rgba(255, 255, 255, 0.551109) 0%, rgba(255, 255, 255, 0.206403) 100%);
            backdrop-filter: blur(20px);
            display: inline-block;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: auto;
                        padding-right: 30px;
                        width: 95%;
                        left: 30px;
                    `,
                    css`
                        margin: auto;
                        padding-right: 30px;
                        width: 90%;
                    `,
                    css`
                        margin: auto;
                        padding-right: 30px;
                    `,
                    css`
                        margin: auto;
                        padding-right: 10px;
                    `,

                    null,
                ])}
        `,
    },
    twrapper: {
        variant: "h3",
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.dosis};
            font-weight: ${TYPOGRAPHY.weight.baseBold};
            color: ${COLORS.black};
            width: auto;
            font-size: ${TYPOGRAPHY.size.larger};
            margin-top: 21px;
            margin-bottom: 18px;
            margin-left: 18px;
        `,
    },
    h1wrapper: {
        css: css`
            width: auto;
            border-radius: 25px 0 0 25px;
            background-color: ${getColor("warning")};
            margin-left: 18px;
            &:hover {
                background-color: ${getColor("warning.contrast")};
            }
            span {
                font-size: ${TYPOGRAPHY.size.smallest} !important;
                padding: 2px 10px;
                opacity: 1;
                color: ${COLORS.black} !important;
                font-weight: ${TYPOGRAPHY.weight.baseBold};
                font-style: normal;
                letter-spacing: ${TYPOGRAPHY.letterSpacing.vSmaller};
                text-align: left;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        span {
                            font-size: ${TYPOGRAPHY.size.tiny} !important;
                        }
                    `,
                    css`
                        span {
                            font-size: ${TYPOGRAPHY.size.tiny} !important;
                        }
                    `,
                    css`
                        span {
                            font-size: ${TYPOGRAPHY.size.tiny} !important;
                        }
                    `,
                    null,

                    null,
                ])}
        `,
    },
    h2wrapper: {
        css: css`
            display: flex;
            width: auto;
            border: 1px solid ${COLORS.normalGray};
            border-radius: 0 25px 25px 0;
            background: linear-gradient(to bottom, #ffffff 55%, #ffffff 100%);
            font-size: ${TYPOGRAPHY.size.smallest};
            padding: 0 11px;
            &:hover {
                &.circle {
                    background: ${COLORS.yellow};
                    border: 0.25px solid rgba(17, 41, 69, 0.22);
                    box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, 0.64);
                }
            }
            span {
                color: ${COLORS.black} !important;
                font-size: ${TYPOGRAPHY.size.smallest} !important;
                opacity: 1;
                font-weight: ${TYPOGRAPHY.weight.baseBold};
                font-style: normal;
                letter-spacing: ${TYPOGRAPHY.letterSpacing.vSmaller};
                text-align: left;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        span {
                            font-size: ${TYPOGRAPHY.size.tiny} !important;
                        }
                    `,
                    css`
                        span {
                            font-size: font-size: ${TYPOGRAPHY.size.tiny} !important;
                        }
                    `,
                    css`
                        span {
                            font-size: font-size: ${TYPOGRAPHY.size.tiny} !important;
                        }
                    `,
                    null,

                    null,
                ])}
        `,
    },
    buttonWrapper: {
        css: css`
            display: flex;
            gap: 4px;
        `,
    },
    circle: {
        css: css`
            content: "";
            width: 11px;
            margin-left: 10px !important;
            height: 11px;
            border-radius: 50%;
            display: inline-block;
            position: relative;
            margin: auto;
            left: 0px;
            border-radius: 5.499547px;
            border: 0.25px solid rgba(17, 41, 69, 0.219214);
            box-shadow: 0px 0px 2px rgb(0 0 0 / 64%) inset;
            opacity: 1;
            background-color: ${COLORS.background.whiteSmoke};
            &:hover {
                background: ${COLORS.yellow};
                border: 0.25px solid rgba(17, 41, 69, 0.22);
                box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, 0.64);
            }
        `,
    },
    parentContainer: {
        css: css`
            position: relative;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100% !important;
                            max-width: 100% !important;
                            flex-basis: 100% !important;
                        `,
                        css`
                            width: 100% !important;
                            max-width: 100% !important;
                            flex-basis: 100% !important;
                        `,
                        css`
                            width: 100% !important;
                            max-width: 100% !important;
                            flex-basis: 100% !important;
                        `,
                        null,
                    ],
                    "minMax",
                )};
        `,
    },
    parent: {
        gap: 30,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        > div[class^="GridOffset"] {
                            width: 100%;
                            margin: 0 auto;
                        }
                    `,
                    css`
                        > div[class^="GridOffset"] {
                            width: 100%;
                            margin: 0 auto;
                        }
                    `,
                    css`
                        > div[class^="GridOffset"] {
                            width: 100%;
                            margin: 0 auto;
                        }
                    `,
                    null,

                    null,
                ])}
        `,
    },
    styleIcon: {
        css: css`
            padding: 0;
            width: auto;
            margin-right: 6px;
            svg {
                width: 10px;
                height: 10px;
            }
        `,
    },
    description: {
        css: css`
            color: ${COLORS.black};
            font-family: ${TYPOGRAPHY.fontFamily.montserrat};
            font-size: ${TYPOGRAPHY.size.small};
            font-weight: ${TYPOGRAPHY.weight.base};
            letter-spacing: ${TYPOGRAPHY.letterSpacing.smallest};
            width: 100%;
            max-width: 350px;
            margin-left: 18px;
            margin-bottom: 20px;
        `,
    },
};

const styles = imgstyle;

export const SupportBannerWidget: FC<OwnProps & ReturnType<typeof mapStateToProps>> = ({ fields, currentPage }) => {
    return (
        <>
            <StyledWrapper {...styles.main}>
                <Typography as="h2" {...styles.title}>
                    {" "}
                    {fields.maintitle}
                </Typography>
                <GridContainer {...styles.parent}>
                    {fields.divisions?.map((division, index) => {
                        const backgroundStyle = `background-image: url(${division.fields.img});`;
                        const links1 = useGetLinks(fields.divisions, o => o.fields.path1);
                        const links2 = useGetLinks(fields.divisions, o => o.fields.path2);

                        const head = {
                            css: css`
                                border-radius: 5px;
                                width: 100%;
                                height: 100%;
                                padding-top: 102px;
                                padding-left: 20px;
                                padding-bottom: 20px;
                                ${backgroundStyle};
                                background-size: cover;
                                background-color: ${currentPage.name === "Home" ? COLORS.lightGrey : "inherit"};

                                &::after {
                                    content: "";
                                    position: absolute;
                                    bottom: 0px;
                                    right: 0px;
                                    clip-path: polygon(100% 0px, 0% 100%, 100% 100%);
                                    width: 60px;
                                    height: 65px;
                                    background-color: inherit;
                                }

                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(theme, [
                                        css`
                                            width: 100%;
                                        `,
                                        css`
                                            width: 100%;
                                        `,
                                        css`
                                            width: 100%;
                                        `,
                                        null,
                                        null,
                                    ])}
                            `,
                        };
                        return (
                            <GridItem
                                {...styles.parentContainer}
                                style={{
                                    width: `calc(100% / ${fields.selectColumn})`,
                                    maxWidth: `calc(100% / ${fields.selectColumn})`,
                                    flexBasis: `calc(100% / ${fields.selectColumn})`,
                                }}
                            >
                                <StyledWrapper {...head}>
                                    {/* <LazyImage {...styles.img} src={division.fields.img} /> */}
                                    <StyledWrapper {...styles.imgwrapper}>
                                        <Typography as="h3" {...styles.twrapper}>
                                            {division.fields.title}
                                        </Typography>
                                        {division.fields.description && (
                                            <StyledWrapper {...styles.description}>
                                                {parse(division.fields.description, parserOptions)}
                                            </StyledWrapper>
                                        )}
                                        <StyledWrapper {...styles.buttonWrapper}>
                                            {division.fields.lowerText1 && (
                                                <StyledWrapper {...styles.h1wrapper}>
                                                    <Link href={links1[index].url} {...styles.button}>
                                                        {division.fields.lowerText1}
                                                    </Link>
                                                </StyledWrapper>
                                            )}
                                            {division.fields.lowerText2 && (
                                                <StyledWrapper {...styles.textCircleContainer}>
                                                    <StyledWrapper {...styles.h2wrapper}>
                                                        <Link href={links2[index].url} {...styles.button}>
                                                            <Icon {...styles.styleIcon} src={Search} />
                                                            {division.fields.lowerText2}
                                                        </Link>
                                                        <StyledWrapper
                                                            {...styles.circle}
                                                            className="circle"
                                                        ></StyledWrapper>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            )}
                                        </StyledWrapper>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </GridItem>
                        );
                    })}
                </GridContainer>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(SupportBannerWidget),
    definition: {
        group: "Basic",
        displayName: "SupportBannerWidget",
        fieldDefinitions: [
            {
                name: "maintitle",
                fieldType: "Translatable",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: "selectColumn",
                displayName: "Select Column Width",
                editorTemplate: "DropDownField",
                defaultValue: 2,
                options: [1, 2].map(value => ({ value })),
                fieldType: "General",
            },
            {
                name: fields.divisions,
                editorTemplate: "ListField",
                getDisplay: ({ fields: { title } }) => title || "title",
                defaultValue: [],
                fieldType: "Translatable",

                fieldDefinitions: [
                    {
                        name: "img",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        displayName: "Background Image",
                    },
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "description",
                        editorTemplate: "RichTextField",
                        defaultValue: "",
                    },
                    {
                        name: "lowerText1",
                        displayName: "Button Text 1",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "path1",
                        displayName: "Button Link 1",
                        editorTemplate: "LinkField",
                        defaultValue: { type: "Page", value: "" },
                    },
                    {
                        name: "lowerText2",
                        displayName: "Button Text 2",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "path2",
                        displayName: "Button Link 2",
                        editorTemplate: "LinkField",
                        defaultValue: { type: "Page", value: "" },
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
